import { withTheme, WithTheme } from '@emotion/react'
import { Theme } from '@instacart/ids-core'

export type WithThemeProps = WithTheme<unknown, Theme>

export { withTheme }
export default withTheme
